import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAxWkg_71Hv5P92qEOCaCnPY7y_VHbzagI",
  authDomain: "million2trillion-4d06a.firebaseapp.com",
  projectId: "million2trillion-4d06a",
  storageBucket: "million2trillion-4d06a.appspot.com",
  messagingSenderId: "77254952767",
  appId: "1:77254952767:web:e638810c8e7cc879dd358a"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
